import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import { TABLET_P } from '@/constants';
import ContentfulImage from '../../components/ContentfulImage';
import Placeholder from '../../components/Placeholder';
import media from '../../styles/media.style';
import { contentTypeToSlug } from '../RangePage/rangeNameConverter';

const HeaderContainer = styled.section`
  max-width: 1440px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  ${media.tabletL`
    margin-left: auto;
    margin-right: auto;
  `};
`;
const HeaderImgCover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 40px;
  ${media.tabletP`
    margin-bottom: 0;
  `};
`;
const HeaderTitleCover = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-left: 0;
`;
const HeaderTitleText1 = styled.div`
  // font-family: FuturaPT-Medium;
  font-size: 18px;
  color: #000;
  ${media.tabletP`
      margin-top: 40px;
  `};
  ${media.tabletL`
      margin-top: 40px;
  `};
`;
const HeaderTitleText2 = styled.div`
  // font-family: HiraKakuStd-W3;
  font-size: 30px;
  letter-spacing: 3px;
  margin-top: 10px;
  color: #000;
  ${media.tabletL`
      margin-top: 30px;
  `};
`;
const HeaderTitleButton = styled.div`
  width: 320px;
  height: 64px;
  margin-top: 40px;
  margin-bottom: 40px;
  color: #fff;
  background-color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${media.tabletP`
      margin-top: 40px;
      margin-bottom: 40px;
  `};
  ${media.tabletL`
      margin-top: 40px;
      margin-bottom: 40px;
  `};
`;

class LineHeader extends Component {
  static defaultProps = {
    product: {},
    copy: {},
    locale: undefined,
  };

  static propTypes = {
    product: PropTypes.shape(),
    copy: PropTypes.shape(),
    locale: PropTypes.string,
  };

  render() {
    const { copy, product, locale } = this.props;
    return (
      <HeaderContainer>
        {/* イメージ画像部分 */}
        {!product.product ? (
          <Placeholder
            w={window.innerWidth > TABLET_P ? '960px' : '100%'}
            h={window.innerWidth > TABLET_P ? '450px' : '176px'}
            m="0 0 40px 0"
          />
        ) : (
          <HeaderImgCover>
            <ContentfulImage src={product.product.mainVisual} marginSet="0" objectPosition="relative" />
          </HeaderImgCover>
        )}
        <HeaderTitleCover>
          {/* 見出し (サブカテゴリ、または LINE 表示部分) */}
          {!(product && _.get(product, 'product')) ? (
            <Placeholder w="146px" h="27px" />
          ) : (
            <HeaderTitleText1>{product.product.name}</HeaderTitleText1>
          )}
          {/* 「取り扱いサロン一覧」表示部分 */}
          {!(copy && _.get(copy, 'handle_salon_list')) ? (
            <Placeholder w="297px" h="45px" m="30px 0 0 0" />
          ) : (
            <HeaderTitleText2>{copy.handle_salon_list}</HeaderTitleText2>
          )}
          {product ? '' : <Placeholder w="320px" h="64px" />}
          {/* 「商品詳細はこちら」ボタン */}
          {!_.get(product, 'product') ? (
            <Placeholder w="320px" h="64px" m="40px 0 40px 0" />
          ) : (
            <HeaderTitleButton>
              <Link
                to={`/${locale}/range/${contentTypeToSlug(product.product.contentType)}/${product.product.slug}`}
                href={`/${locale}/range/${contentTypeToSlug(product.product.contentType)}/${product.product.slug}`}
              >
                {copy.cta_label}
              </Link>
            </HeaderTitleButton>
          )}
        </HeaderTitleCover>
      </HeaderContainer>
    );
  }
}

const mapState = state => ({
  copy: state.siteOptions.siteCopySalonList,
  locale: state.locale,
});

export default connect(mapState)(LineHeader);



// WEBPACK FOOTER //
// ./src/pages/SalonList/LineHeader.js